import React from "react";

function Vid() {
  return (
    <div className="relative overflow-hidden bg-white">
        {/* YouTube Video Section */}
        <div className="mt-10 relative max-w-5xl mx-auto rounded-xl overflow-hidden shadow-lg">
          {/* Responsive iframe */}
          <div className="relative w-full h-0 pb-[56.25%] "> 
           <iframe className="w-full h-[300px] md:h-[400px] rounded-xl" src="https://www.youtube.com/embed/Gb3LrUC21Eo?autoplay=1&mute=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
           </iframe>
          </div>
        </div>
      </div>
  );
}

export default Vid;